import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Digital Cost">
                            <h2>Supercharge Your Online Business With A Marketplace Digital Service</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>Digital marketplaces, including general and product-focused, are the quickest examples of
                            digital commerce transformation, adding to the global revenues in the retail and ecommerce
                            sectors. These digital ecosystems help modern entrepreneurs capitalize on the need for
                            platforms by eliminating the concerns of scale, sourcing, quality, and reliability.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;